export enum PaymentResultType {
  Success = "success",
  Error = "error",
  Cancellation = "cancellation",
}
